<script>
import Layout from "../../layouts/main";
import Loader from "@/components/widgets/loader";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ODuyuru from "@/components/widgets/ODuyuru";
import {  MethodsActionsLoginSessionKey } from "@/state/helpers";
import store from "@/state/store"; 
import AddEdit from "./AddEdit.vue";


 
export default {
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    ODuyuru,
    AddEdit,
  },
  data() {
    return {
      title: this.$t('StrAnasayfa.Title'),
      items: [
         
        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],  
      fetchingStats: true, 
      KullaniciYetkileri : store.getters["auth/UserRolles"],
      AuthKontrol: store.getters["auth/isAuth"],
      loading: true,
      yeni_duyurular:[]
    };
  }, 
  methods:{
    ...MethodsActionsLoginSessionKey,
    Get(){},

    YeniDuyurular( data ){
      this.yeni_duyurular=data;
      this.$bvModal.show("StrDuyurular");

    }
  },
  created(){     
    if(!this.AuthKontrol){ 
        if(this.$route.params.Sessionkey && this.$route.params.Email){
        let Data={
          Email: this.$route.params.Email,
          Sessionkey: this.$route.params.Sessionkey
        }  
         this.ActionsLoginSessionKey(Data).then((res) => {    
         
          if (res == true) { 
           window.location.href = "/";
          }  else{
           window.location=this.$config.LOGIN_URL
          } 
          
          this.loading = false;
        
        });
      } 
  }
  else{
  
          this.loading = false;
    
  }}
};
</script>

<template>
  <Loader :loading="loading">
  <Layout  v-if="AuthKontrol" >
    <PageHeader :title="title" :items="items" v-if="AuthKontrol" /> 
  
        <ODuyuru :updating="fetchingStats" @yenidata="YeniDuyurular($event)" v-if="AuthKontrol && KullaniciYetkileri.length > 0 && !loading" />

        <div class="row" v-if=" AuthKontrol && KullaniciYetkileri.length == 0 && !loading">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center p-5">
              <h3>Yetkiniz bulunmamaktadır lütfen yetki talep edin.</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>

      <AddEdit  :duyurular="yeni_duyurular"/>

</Loader>





</template>
